import React from "react";
import { AlarmClockIcon } from "lucide-react";
import { useLoopingCountdown } from "../hooks/useLoopingCountdown";
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown();
  const units = [{
    label: "Hours",
    value: hours
  }, {
    label: "Minutes",
    value: minutes
  }, {
    label: "Seconds",
    value: seconds
  }];
  return <div className="w-full rounded-2xl bg-alert-soft p-4 text-center" role="timer" aria-live="off" data-id="element-20" data-mp="3pzav33bpgms5">
      <p className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-wide text-alert" data-id="element-21" data-mp="3c48pyieon1ge">
        <AlarmClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-22" data-mp="323yfh5k1884x" />
        Promotional price ends in:
      </p>
      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-23" data-mp="3729pbgabuin5">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="10c3fvob1vu32" data-mpi={i}>
            <div className="flex min-w-0 max-w-[5.5rem] flex-1 flex-col items-center rounded-xl bg-navy-900 py-2.5" data-id="element-25" data-mp="10d4qjro5mek9">
              <span className="font-display text-4xl font-extrabold tabular-nums leading-none text-white" data-id="element-26" data-mp="1592a06ups119">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className="mt-1 text-[10px] font-semibold uppercase tracking-wide text-white/70" data-id="element-27" data-mp="t1tnxwhhhiae">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="font-display text-3xl font-extrabold text-navy-900" aria-hidden="true" data-id="element-28" data-mp="12tzqu199xk4d">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}